/**
 * Vendor Store (Zustand)
 * Manages vendor profile, status, and stats
 */

import { create } from 'zustand';
import { VendorStatus } from '@/lib/constants';

interface VendorStats {
  totalOrders: number;
  activeOrders: number;
  completedToday: number;
  avgPrepTime: number;
  cancelRate: number;
  rating: number;
}

interface VendorState {
  status: VendorStatus;
  capacity: number;
  stats: VendorStats | null;
  isLoading: boolean;

  // Actions
  setStatus: (status: VendorStatus) => void;
  setCapacity: (capacity: number) => void;
  setStats: (stats: VendorStats) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

const initialStats: VendorStats = {
  totalOrders: 0,
  activeOrders: 0,
  completedToday: 0,
  avgPrepTime: 0,
  cancelRate: 0,
  rating: 0,
};

export const useVendorStore = create<VendorState>((set) => ({
  status: 'inactive', // Sprint 27: Aligned with database enum
  capacity: 10,
  stats: initialStats,
  isLoading: false,

  setStatus: (status) =>
    set({
      status,
    }),

  setCapacity: (capacity) =>
    set({
      capacity,
    }),

  setStats: (stats) =>
    set({
      stats,
    }),

  setLoading: (loading) =>
    set({
      isLoading: loading,
    }),

  reset: () =>
    set({
      status: 'inactive', // Sprint 27: Aligned with database enum
      capacity: 10,
      stats: initialStats,
      isLoading: false,
    }),
}));


















